var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPacmanYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 54,
    viewBox: "0 0 51 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2451 12.6408V10.8462H43.4506V9.05104H41.6554V7.25649H39.8608H38.0656V5.4613H36.2711H34.4759V3.66675H32.6813H30.8861H29.0916H27.2964L25.5018 3.66675H23.7066H21.9121H20.1169V5.4613H18.3224H16.5272V7.25649H14.7326H12.9374V9.05104H11.1429V10.8462H9.34767V12.6408H7.55312V14.436V16.2305H5.75793V18.0257V19.8203V21.6155H3.96338V23.41V25.2052L3.96338 26.9998V28.795V30.5895V32.3847H5.75793V34.1792V35.9744V37.769H7.55312V39.5642V41.3587H9.34767V43.1539H11.1429V44.9485H12.9374V46.7437H14.7326H16.5272V48.5382H18.3224H20.1169V50.3334H21.9121H23.7066H25.5018H27.2964H29.0916H30.8861H32.6813H34.4759V48.5382H36.2711H38.0656V46.7437H39.8608H41.6554V44.9485H43.4506V43.1539V41.3587H41.6554V39.5642H39.8608V37.769H38.0656V35.9744H36.2711V34.1792H34.4759V32.3847H32.6813V30.5895H30.8861V28.795H32.6813V26.9998H34.4759V25.2052H36.2711V23.41H38.0656V21.6155H39.8608V19.8203H41.6554V18.0257H43.4506V16.2305H45.2451V14.436H47.0403V12.6408H45.2451Z",
    fill: "#FED200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9371 34.1791V32.3845H11.1426V34.1791V35.9743H12.9371V37.7688H14.7323V35.9743V34.1791H12.9371Z",
    fill: "#FCF500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.527 37.7688H14.7324V39.5634H16.527V37.7688Z",
    fill: "#FCF500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6811 41.3586H30.8859V43.1538H29.0913V44.9484H30.8859H32.6811V43.1538H34.4756V41.3586H32.6811Z",
    fill: "#FCF500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1422 16.2302H9.34766V18.0248H11.1422V16.2302Z",
    fill: "#FFE885"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9376 14.4358H11.1431V16.2303H12.9376V14.4358Z",
    fill: "#FFE885"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9119 7.25635H20.1167V9.0509V10.8461H21.9119H23.7064V9.0509V7.25635H21.9119Z",
    fill: "#FFE885"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1168 10.8462H18.3223V12.6407V14.4359H20.1168H21.912V12.6407V10.8462H20.1168Z",
    fill: "#FFE885"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1168 9.05103H18.3223V10.8462V12.6408H20.1168H21.912V10.8462V9.05103H20.1168Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8345 12.6433H47.0399V14.4379H45.2447V16.2324H43.4502V18.027H41.655V19.8215H39.8604V21.6161H38.0652V23.4106H36.2707V25.2052H34.4755V26.9997H32.6809V28.7943H30.8857V30.5895H32.6803V30.5901H32.6809V32.3847H34.4748H34.4755V34.1792H36.27H36.2707V35.9744H38.0652V37.769H39.8598H39.8604V39.5642H41.655V41.3587H43.4495V43.1539V44.9484H45.2447V43.1539V41.3587V39.5642H43.4495V37.769H41.655V35.9744H39.8604H39.8598V34.1792H38.0652H38.0646V32.3847H36.2707H36.27V30.5895H34.4755H34.4748V28.7949H32.6809H34.4755V28.7943H36.27V27.0004H36.2707V25.2058V26.9991H38.0659V25.2045H38.0652V23.4113H38.0659V25.2039H39.8611V23.4093H39.8604V21.6167H39.8611V23.4087H41.6563V21.6135H41.655V19.8222H41.6569V21.6135H43.4514V19.8183H43.4502V18.0276H43.4521V19.8183H45.2466V18.0231H45.2447V16.2331H45.2473V18.0225H47.0418V16.2279H47.0399V14.4385H47.0425V16.2273H48.8377V14.4385H50.6297V12.6433H48.8345Z",
    fill: "#472B00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8346 10.8481H47.04V12.6427H48.8346V10.8481Z",
    fill: "#472B00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2449 10.8474H45.2437V12.642H47.0388V10.8474H47.0401V9.05225H45.2449V10.8474Z",
    fill: "#472B00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4503 9.05099H43.4478V10.8462H45.2423V9.05227H45.2449V7.25708H43.4503V9.05099Z",
    fill: "#472B00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6552 7.25519H41.6514V9.04974H43.4466V7.25647H43.4504V5.46191H41.6552V7.25519Z",
    fill: "#472B00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96057 16.2304H3.96121V18.0237H5.75576V16.2304H7.54904V14.4378V14.4358V12.6426H7.54776V10.8538H5.75321V12.649H5.75384V14.4358V14.4378V16.2285H5.75193V14.4454V14.4358V12.6509H3.95674V14.4358V14.4454V16.2266H2.16602V18.0211H3.96057V16.2304Z",
    fill: "#472B00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96057 18.0256H2.16602V19.8202H3.96057V18.0256Z",
    fill: "#472B00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8607 48.5381H38.0655V50.3333H36.271V52.1278H38.0655V50.3333H39.8607H41.6553V48.5381H39.8607Z",
    fill: "#472B00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2446 43.1538V44.9484H47.0398V43.1538V41.3586H45.2446V43.1538Z",
    fill: "#472B00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6816 3.66537H34.4762V3.66665V5.45992H36.2707V3.66665H36.272V5.45992H38.0653V7.25384H39.8554H39.8605H41.6499V5.4612H41.655V3.66601H39.8605H38.0666V3.66537H38.0659V1.87146H36.2707H34.4762V1.87082V0.0769043L32.6816 0.0769043V1.87146V3.66537Z",
    fill: "#472B00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6809 1.87146V1.87082V0.0769043L30.8857 0.0769043V1.87082V1.87146V3.66537H32.6809V1.87146Z",
    fill: "#472B00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.885 1.87146V0.0769043L29.0898 0.0769043V1.87082V3.66537H30.885V1.87146Z",
    fill: "#472B00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0896 1.87146V0.0769043L27.2951 0.0769043V1.87082H27.2944V3.66537H29.0896V1.87146Z",
    fill: "#472B00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2937 1.87146H27.2944V0.0769043L25.4992 0.0769043V1.87082H25.4985V3.66537H27.2937V1.87146Z",
    fill: "#472B00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7322 7.25448H16.5248V5.4612H16.5268V5.45737H18.3194H18.3219H20.1139V3.66537H21.9059V1.87146H21.9066V3.66537H23.7018V1.87146H23.7024V3.66537H25.4976V1.87146H25.4982V0.0769043L23.7037 0.0769043V1.87082H23.7031V0.0769043L21.9079 0.0769043V1.87082H21.9072V0.0769043L20.112 0.0769043V1.87018H18.3219H18.3188H16.5268V3.66282V3.66537V3.66665H14.7322H12.9376V5.45929H12.937V7.25448H14.7303H14.7322Z",
    fill: "#472B00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9368 7.25833V7.25514V5.46313H11.1416V7.25514V7.25833V9.05033H12.9368V7.25833Z",
    fill: "#472B00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3457 10.8462H11.1409V9.05098H11.1403V7.26025H9.3457V9.05481V10.8462Z",
    fill: "#472B00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54947 12.642H9.34466V10.8468H9.34402V9.05737H7.54883V10.8519H7.54947V12.642Z",
    fill: "#472B00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75598 18.0256H3.96143V19.8202H5.75598V18.0256Z",
    fill: "#472B00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6811 50.3332H30.8859H29.0913H27.2961H25.5016H23.7064H21.9118H20.1167V48.5381H18.3221H16.5269V46.7435H14.7324H12.9372V44.9483H11.1426V43.1538H9.34743V41.3586H7.55287V39.564V37.7688H5.75768V35.9743V34.1791V32.3845H3.96313V30.5893V28.7948V26.9996V25.205V23.4099V21.6172H5.75577V19.822H3.96121V21.6153H3.96058V19.8239H2.16602V21.6159H0.374023L0.374023 23.4099V23.4111V25.2038V25.205V26.9977V26.999L0.374023 28.7916V28.7929V30.5855V30.5868V32.3807H2.16794V32.3845V34.1791V35.9743V37.7688H3.96313V39.564V41.3586H5.75768V43.1538H7.55287V44.9483H9.34743V46.7435H11.1426V48.5381H12.9372V50.3332H14.7324H16.5269V52.1278H18.3221H20.1167V53.923H21.9118H23.7064H25.5016H27.2961H29.0913H30.8859H32.6811H34.4756V52.1278H36.2708V50.3332H34.4756H32.6811Z",
    fill: "#472B00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0653 50.3327V48.5381H39.8599V46.7429H38.0653V48.5381H36.2708H34.4756V50.3327H36.2708H38.0653Z",
    fill: "#472B00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6549 46.743H39.8604V48.5382H41.6549H43.4501V46.7437H45.2446V44.9485H43.4495H41.6549V46.743Z",
    fill: "#472B00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6554 41.3587H39.8608V43.1539H38.0656H36.2711V44.9484H34.4759V46.7436H32.6813H30.8861H29.0916H27.2964H25.5018H23.7067H21.9121H20.1169V44.9484H18.3224H16.5272V43.1539H14.7326V41.3587H12.9374V39.5641H11.1429V37.7689H9.34768V35.9744V34.1792H7.55312V32.3846V30.5894V28.7949V26.9997V25.2051V23.41V21.6154V19.8202V18.0257V16.2305H5.75793V18.0257V19.8202V21.6154H3.96338V23.41V25.2051V26.9997V28.7949V30.5894V32.3846H5.75793V34.1792V35.9744V37.7689H7.55312V39.5641V41.3587H9.34768V43.1539H11.1429V44.9484H12.9374V46.7436H14.7326H16.5272V48.5382H18.3224H20.1169V50.3334H21.9121H23.7067H25.5018H27.2964H29.0916H30.8861H32.6813H34.4759V48.5382H36.2711H38.0656V46.7436H39.8608H41.6554V44.9484H43.4506V43.1539V41.3587H41.6554Z",
    fill: "#FFA31A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34778 14.4361V12.6409H7.55322V14.4361V16.2306H9.34778V14.4361Z",
    fill: "#FFA31A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1422 10.8462H9.34766V12.6407H11.1422V10.8462Z",
    fill: "#FFA31A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7328 10.8463V9.05114V7.25659H12.9376V9.05114H11.1431V10.8463H12.9376H14.7328Z",
    fill: "#FFA31A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3219 5.46118H16.5273V7.25573H18.3219V5.46118Z",
    fill: "#FFA31A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9113 3.66675H20.1167V5.4613H21.9113V3.66675Z",
    fill: "#FFA31A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6535 7.25844V5.46325H39.859V3.6687H38.0638H36.2692H34.474V5.46325H32.6795V7.25844H30.8843V9.053V10.8482V12.6427V14.4379H32.6795V16.2325H34.474V18.0277H36.2692H38.0638H39.859V16.2325H41.6535V14.4379H43.4487V12.6427V10.8482V9.053V7.25844H41.6535Z",
    fill: "#FEFEFE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4742 5.46313H32.6797V7.25769H34.4742V5.46313Z",
    fill: "#472B00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0639 5.46325H39.8591V3.6687H38.0639H36.2693H34.4741V5.46325H36.2693H38.0639Z",
    fill: "#472B00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6534 5.46313H39.8589V7.25769H41.6534V5.46313Z",
    fill: "#472B00"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6533 7.25854V9.0531V10.8483V12.6428V14.438H43.4485V12.6428V10.8483V9.0531V7.25854H41.6533Z",
    fill: "#472B00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6795 10.8483V9.0531V7.25854H30.8843V9.0531V10.8483V12.6428V14.438H32.6795V12.6428V10.8483Z",
    fill: "#472B00"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4742 14.438H32.6797V16.2325H34.4742V14.438Z",
    fill: "#472B00"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2693 16.2324H34.4741V18.0276H36.2693H38.0639H39.8591V16.2324H38.0639H36.2693Z",
    fill: "#472B00"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6534 14.438H39.8589V16.2325H41.6534V14.438Z",
    fill: "#472B00"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M38.064 14.4379H36.2694V12.6427H34.4742V10.8481H32.6797V12.6427V14.4379H34.4742V16.2324H36.2694H38.064H39.8592V14.4379H38.064Z",
    fill: "#CAF0FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M39.858 7.25854H38.0635V9.0531H39.858V7.25854Z",
    fill: "#573400"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0636 9.05298H36.269V10.8475H38.0636V9.05298Z",
    fill: "#573400"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0636 7.25854H36.269V9.0531H38.0636V7.25854Z",
    fill: "#472B00"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M39.858 9.05298H38.0635V10.8475H39.858V9.05298Z",
    fill: "#472B00"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6809 10.8463V9.05114H30.8857V7.25659H29.0911H27.2959H25.5014V9.05114H23.7062V10.8463H21.9116V12.6409V14.4361V16.2306V18.0258H23.7062V19.8204H25.5014V21.6156H27.2959H29.0911H30.8857V19.8204H32.6809V18.0258H34.4754V16.2306V14.4361V12.6409V10.8463H32.6809Z",
    fill: "#FEFEFE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5006 9.05103H23.7061V10.8456H25.5006V9.05103Z",
    fill: "#472B00"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0912 9.05114H30.8858V7.25659H29.0912H27.296H25.5015V9.05114H27.296H29.0912Z",
    fill: "#472B00"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6803 9.05103H30.8857V10.8456H32.6803V9.05103Z",
    fill: "#472B00"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6807 10.8464V12.641V14.4362V16.2307V18.0259H34.4752V16.2307V14.4362V12.641V10.8464H32.6807Z",
    fill: "#472B00"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7062 14.4362V12.641V10.8464H21.9116V12.641V14.4362V16.2307V18.0259H23.7062V16.2307V14.4362Z",
    fill: "#472B00"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5006 18.0259H23.7061V19.8204H25.5006V18.0259Z",
    fill: "#472B00"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M27.296 19.8203H25.5015V21.6155H27.296H29.0912H30.8858V19.8203H29.0912H27.296Z",
    fill: "#472B00"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6803 18.0259H30.8857V19.8204H32.6803V18.0259Z",
    fill: "#472B00"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M29.091 18.0258H27.2958V16.2306H25.5012V14.436H23.7061V16.2306V18.0258H25.5012V19.8203H27.2958H29.091H30.8855V18.0258H29.091Z",
    fill: "#CAF0FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8859 10.8464H29.0913V12.641H30.8859V10.8464Z",
    fill: "#573400"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0905 12.6409H27.2959V14.4354H29.0905V12.6409Z",
    fill: "#573400"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0905 10.8464H27.2959V12.641H29.0905V10.8464Z",
    fill: "#472B00"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8859 12.6409H29.0913V14.4354H30.8859V12.6409Z",
    fill: "#472B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPacmanYellow);
export default __webpack_public_path__ + "static/media/IconPacmanYellow.f19fdad3c28399d80dad6f6c04e66790.svg";
export { ForwardRef as ReactComponent };